import { hideScrollbar } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

export const header = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(${spacing.sm});
  margin-bottom: var(${spacing.md});
`;

export const heading = css`
  margin: 0;
  font-family: var(${typography.heading.fontFamily});
  font-weight: var(${typography.heading.fontWeight});
  font-size: var(${typography.heading.sizes.md.fontSize});
  line-height: var(${typography.heading.sizes.md.lineHeight});
  letter-spacing: var(${typography.heading.letterSpacing});
  color: var(${colors.content.default});
`;

/* As on the product carousels: a touchscreen swipes the track, so the arrows
   only show for a mouse. */
export const controls = css`
  display: flex;
  flex-shrink: 0;
  gap: var(${spacing.xs});

  @media (any-pointer: coarse) {
    display: none;
  }
`;

/* The top padding keeps the card stacked behind each image inside the scroll
   container, which would otherwise clip it. `isolation` gives those stacked
   cards a context to sit behind their image in, without going under the page. */
export const track = css`
  ${hideScrollbar}

  display: flex;
  gap: var(${spacing.xs});
  margin: 0;
  padding: 4px 0 0;
  overflow-x: auto;
  overflow-y: hidden;
  overscroll-behavior-x: contain;
  scroll-snap-type: x mandatory;
  isolation: isolate;
  list-style: none;
`;

export const item = css`
  flex-shrink: 0;
  scroll-snap-align: start;
`;
